var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "horizontalSide-wrapper flex-sub"
  }, [_c("logo", {
    staticClass: "horizontalSide-logo"
  }), _c("a-menu", {
    staticClass: "side-main",
    attrs: {
      mode: "horizontal",
      theme: "dark",
      selectedKeys: [_vm.$route.path]
    }
  }, [_vm._l(_vm.baseRoute, function (item) {
    return [!item.children && !item.hidden ? _c("menu-item", {
      key: item.path,
      attrs: {
        currentRoute: item
      }
    }) : _vm._l(item.children, function (temp) {
      return [!temp.children ? _c("menu-item", {
        key: temp.path,
        attrs: {
          currentRoute: temp
        }
      }) : _c("sub-menu", {
        key: temp.path,
        attrs: {
          currentRoute: temp
        }
      })];
    })];
  })], 2)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };